import { makeAttachedBlock } from "../attachedBlock";

const block = makeAttachedBlock(
  "attached-skills",
  "The user explicitly activated these skills for this message:"
);

export const buildAttachedSkillsBlock = block.build;
export const prependAttachedSkills = block.prepend;
export const attachedSkillNames = block.names;
export const stripAttachedSkillsBlock = block.strip;

export const LOADED_SKILL_PREFIX = "Loaded skill: ";

export function isLoadedSkillNotice(entry: {
  systemMessage?: { text: string } | null;
}): boolean {
  return entry.systemMessage?.text.startsWith(LOADED_SKILL_PREFIX) ?? false;
}
